import { render } from "./PortalPageHeader.vue?vue&type=template&id=65bce533"
import script from "./PortalPageHeader.vue?vue&type=script&lang=js"
export * from "./PortalPageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__